import './Footer.css';
import { useScrollReveal } from '../useScrollReveal';
import GrainOverlay from '../GrainOverlay';

const Footer = () => {
    const { ref, style } = useScrollReveal();

    return (
        <footer className="Footer grain-light" ref={ref} style={style}>
            <GrainOverlay intensity={0.08} />
            <div className="footer-inner">
                <p className="footer-heading">
                    Let's Build Something Together
                </p>
                <p className="footer-tagline">
                    Made in Switzerland. Imagined with AI.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
